module.exports = __webpack_public_path__ + "static/media/CAT_SELECTIVE.91f65db0.svg";